import { render, staticRenderFns } from "./TestPanel.vue?vue&type=template&id=e5612eca&scoped=true&"
import script from "./TestPanel.vue?vue&type=script&lang=js&"
export * from "./TestPanel.vue?vue&type=script&lang=js&"
import style0 from "./TestPanel.vue?vue&type=style&index=0&id=e5612eca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5612eca",
  null
  
)

export default component.exports